export default "__VITE_ASSET__zkVyZ0PW__"